"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import {
  isPhotoBoothKioskActive,
  PHOTO_BOOTH_KIOSK_CHANGE_EVENT,
} from "@/app/lib/weddingPortal";

export default function KioskRouteGuard() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    function enforceKioskRoute() {
      if (!isPhotoBoothKioskActive()) return;
      if (pathname === "/booth") return;

      router.replace("/booth");
    }

    enforceKioskRoute();
    window.addEventListener("storage", enforceKioskRoute);
    window.addEventListener("focus", enforceKioskRoute);
    window.addEventListener(PHOTO_BOOTH_KIOSK_CHANGE_EVENT, enforceKioskRoute);

    return () => {
      window.removeEventListener("storage", enforceKioskRoute);
      window.removeEventListener("focus", enforceKioskRoute);
      window.removeEventListener(PHOTO_BOOTH_KIOSK_CHANGE_EVENT, enforceKioskRoute);
    };
  }, [pathname, router]);

  return null;
}
